"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _default = new _immutable.Record({
  actualCname: null,
  cosObjectTypeId: null,
  created: null,
  deletable: null,
  domain: null,
  id: null,
  isAnyPrimary: null,
  isDnsCorrect: null,
  isInternalDomain: null,
  isLegacy: null,
  isLegacyDomain: null,
  isResolving: null,
  isResolvingIgnoringManuallyMarkedAsResolving: null,
  isSslEnabled: null,
  isSslOnly: null,
  label: null,
  manuallyMarkedAsResolving: null,
  markSslOnlyAfterProvisioning: null,
  portalId: null,
  primaryBlog: null,
  primaryBlogPost: null,
  primaryClickTracking: null,
  primaryEmail: null,
  primaryLandingPage: null,
  primaryLegacyPage: null,
  primarySitePage: null,
  secondaryToDomain: null,
  siteId: null,
  updated: null
}, 'Domain');

exports.default = _default;
module.exports = exports.default;